import _ from 'lodash';
import { CRUISE_PAY_SCHEDULE_DEPOSIT, CRUISE_PAY_SCHEDULE_FINAL_PAY } from '../constants';

const getCruisePriceBreakdownTotals = (priceBreakdown, customCruisePaymentAmounts) => {
  let totalAmount = 0; let commission;
  let errors; const paymentSchedules = [];
  let totalDueNowAmount = 0;

  if (priceBreakdown && priceBreakdown.length) {
    let totalCommission = 0;
    let totalCruiseBaseRates = 0;
    priceBreakdown.forEach((pb, index) => {
      if (pb.errors) {
        errors = pb.errors;
        return;
      }

      const deposit = pb.paymentSchedule
        && pb.paymentSchedule.find((l) => l.title === CRUISE_PAY_SCHEDULE_DEPOSIT);

      const finalPayment = pb.paymentSchedule && pb.paymentSchedule
        .find((l) => l.title === CRUISE_PAY_SCHEDULE_FINAL_PAY);
      paymentSchedules[index] = {
        deposit,
        finalPayment: pb.paymentSchedule
        && (finalPayment || _.last(_.sortBy(pb.paymentSchedule, (s) => +s.amount))),
        roomIndex: pb.roomIndex,
      };

      const customPaymentAmount = customCruisePaymentAmounts
        && _.find(customCruisePaymentAmounts,
          (p) => p && p.roomIndex === pb.roomIndex && p.paymentAmount > 0);
      if (customPaymentAmount) {
        totalDueNowAmount += customPaymentAmount.paymentAmount;
      } else if (deposit) {
        totalDueNowAmount += +deposit.amount;
      }

      const totalAmtStatementLine = pb.totalPassengerStatementLines && pb.totalPassengerStatementLines.find((l) => l.type === 'TOTAL AMOUNT');
      if (totalAmtStatementLine) {
        totalAmount += +totalAmtStatementLine.amount;
      }

      const totalCommAmtStatementLine = pb.agencyStatementLines && pb.agencyStatementLines.find((l) => l.title === 'COMMISSION');
      if (totalCommAmtStatementLine) {
        totalCommission += +totalCommAmtStatementLine.amount;
      }

      // TODO: backend already computing commission amount. de-dupe it.
      // If updating logic, require changes in backend
      // (VectoAPIClient.Cruise.VectoCruiseAPIClient.GetStatementAndPricing) as well
      const totalCruiseBaseRateStatementLines = pb.totalPassengerStatementLines && pb.totalPassengerStatementLines.filter((l) => l.type === 'BASE RATE');
      if (totalCruiseBaseRateStatementLines && totalCruiseBaseRateStatementLines.length > 0) {
        totalCruiseBaseRates += _.sumBy(totalCruiseBaseRateStatementLines, (s) => +s.amount);
      }
    });

    if (totalCommission) {
      commission = {
        percent: +((totalCommission / totalCruiseBaseRates) * 100).toFixed(2),
        amount: totalCommission,
        currencyCode: 'USD',
      };
    } else {
      commission = { percent: 0, amount: 0, currencyCode: 'USD' };
    }
  }

  return {
    totalAmount, commission, errors, paymentSchedules, totalDueNowAmount,
  };
};

export default getCruisePriceBreakdownTotals;
